import { useContext, useEffect, useState } from "react";
import AppContext from "../../Context/AppContext";
import ResightingAvifaunaRecordDetails from "./ResightingAvifaunaRecordDetails";
import {
  annotateAvifaunaResightingComparison,
  buildAvifaunaRecordDetailsFromApi,
} from "./avifaunaRecordDetailsUtils";

function ResightingAvifaunaDetails({ ringNumber, ringSize, digitizedRecord }) {
  const BASE_URL_LOC = process.env.REACT_APP_SERVER_LOCATION;
  const appStates = useContext(AppContext);
  const [record, setRecord] = useState(null);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const trimmedRingNumber = ringNumber ? String(ringNumber).trim() : "";
    const trimmedRingSize = ringSize ? String(ringSize).trim() : "";

    if (!trimmedRingNumber || !trimmedRingSize) {
      setRecord(null);
      setError("Ring number or ring size is missing for Avifauna lookup.");
      setIsLoading(false);
      return;
    }

    let cancelled = false;

    const load = async () => {
      setIsLoading(true);
      setError("");
      setRecord(null);

      try {
        const authToken = appStates.getToken();
        if (!authToken) {
          if (!cancelled) {
            setError("Session expired. Please log in again.");
          }
          return;
        }

        const response = await fetch(
          `${BASE_URL_LOC}/api/resighting/avifauna/ring-details`,
          {
            method: "POST",
            redirect: "follow",
            headers: {
              "Content-Type": "application/json",
              "authentication-token": authToken,
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Headers": "authentication-token",
              "Access-Control-Expose-Headers": "authentication-token",
            },
            mode: "cors",
            body: JSON.stringify({
              ring_number: trimmedRingNumber,
              ring_size: trimmedRingSize,
            }),
          }
        );

        const body = await response.json();
        if (cancelled) {
          return;
        }

        if (!response.ok) {
          setError(body?.error || "Unable to load Avifauna ring history.");
          setRecord(null);
          return;
        }

        const avifaunaRecord = buildAvifaunaRecordDetailsFromApi(body?.data, {
          detailDateFormatOptions: { month: "short", day: "2-digit" },
        });
        setRecord(
          annotateAvifaunaResightingComparison(avifaunaRecord, digitizedRecord)
        );
      } catch {
        if (!cancelled) {
          setError("Unable to load Avifauna ring history.");
          setRecord(null);
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    load();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ringNumber, ringSize, digitizedRecord]);

  return (
    // <div className="resighting-qc-card" style={{ marginTop: "1.5rem" }}>
    //   <h2 className="resighting-qc-section-title">Avifauna</h2>
    <>
      {isLoading ? (
        <p className="resighting-qc-muted">Loading Avifauna ring history...</p>
      ) : error ? (
        <p className="resighting-qc-muted">{error}</p>
      ) : !record?.hasData ? (
        <p className="resighting-qc-muted">No Avifauna records found for this ring.</p>
      ) : (
        <ResightingAvifaunaRecordDetails record={record} />
      )}
    </>
  );
}

export default ResightingAvifaunaDetails;
